import CouplesIcon from '../../../public/assets/icons/couples.svg';
import FamiliesIcon from '../../../public/assets/icons/families.svg';
import GroupsIcon from '../../../public/assets/icons/groups.svg';
import AnimalsIcon from '../../../public/assets/icons/animals.svg';
import ComfortIcon from '../../../public/assets/icons/comfort.svg';
import PriceIcon from '../../../public/assets/icons/inclusive.svg';

export default function PartnerFeatures({ partner }) {
  const stats = [
    {
      name: 'Paare',
      enabled: partner.features.couples,
      icon: CouplesIcon,
    },
    {
      name: 'Familien',
      enabled: partner.features.families,
      icon: FamiliesIcon,
    },
    {
      name: 'Gruppen',
      enabled: partner.features.groups,
      icon: GroupsIcon,
    },
    {
      name: 'Haustiere',
      enabled: partner.features.animals,
      icon: AnimalsIcon,
    },
    {
      name: 'Komfortklasse',
      enabled: partner.features.comfort,
      icon: ComfortIcon,
    },
    {
      name: 'Inklusivleistungen',
      enabled: partner.features.inclusive,
      icon: PriceIcon,
    },
  ];

  return (
    <div className="mb-3 mt-1 overflow-hidden">
      <dl
        className="-ml-4 grid grid-cols-2 divide-gray-200 md:grid-cols-4 md:divide-x gap-y-2"
      >
        {stats.filter((i) => i.enabled).map((item) => (
          <div
            key={item.name}
            className="py-1 pl-4 flex items-center text-primary-600"
            title={`Geeignet für ${item.name}`}
            data-tip={`Geeignet für ${item.name}`}
            data-type="dark"
            data-effect="solid"
          >
            <item.icon className="w-7 mr-3 fill-green-700 flex-shrink-0" />
            <div className="font-semibold line-clamp-1">{item.name}</div>
          </div>
        ))}
      </dl>
      <p className="text-sm mb-1 text-gray-600 uppercase ml-4 mt-2">
        &#8627; Specials bei
        {' '}
        {partner.name}
      </p>
    </div>
  );
}
